import { Logger } from "aws-amplify";

// eslint-disable-next-line
export const amplifyLogger = new Logger("LLTS-Logger", "VERBOSE");
